import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseServiceV2 } from '@servicesv2';
import { ConsultaAutomacaoImpostosResponseViewModel, ConsultaAutomacaoImpostosViewModel } from 'models/itens/ConsultaItensViewModel';
import { ConsultaRapidaItemResponseViewModel } from 'models/itens/ConsultaRapidaItemResponseViewModel';
import { ItensViewModel } from 'models/itens/ItensViewModel';

@Injectable()
export class ItensServiceV2 extends BaseServiceV2 {

  constructor(http: HttpClient) {
    super('Itens', http);
  }

  consultaAutomacaoImpostos(consulta: ConsultaAutomacaoImpostosViewModel) {
    return this.postAsPromise<ConsultaAutomacaoImpostosViewModel, ConsultaAutomacaoImpostosResponseViewModel>(consulta, 'consultaAutomacaoImpostos');
  }

  consultaRapidaItem(produtoId: number) {
    return this.getAsPromise<ConsultaRapidaItemResponseViewModel>(`ConsultaRapidaItem/${produtoId}`);
  }

  consultaItemBalanca(codigo: string) {
    return this.getAsPromise<ItensViewModel>(`ConsultaItemBalanca/${codigo}`);
  }

  consultarItemViaReferencia(referenciaItem: string) {
    return this.getAsPromise<ItensViewModel>(`ConsultaItemViaReferencia/${referenciaItem}`);
  }
}
